// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.name {
  font-family: var(--ons-font-bold);
}

.units {
  margin-left: 10px;
  border-left: 3px solid var(--ons-color-primary);
  padding-left: 10px;
  padding-top: 10px;
}
.units .row {
  display: flex;
  padding-top: 7px;
  padding-bottom: 7px;
}
.units .row .col {
  color: black;
  font-size: 12px;
  text-align: center;
  font-family: var(--ons-font-bold);
}
.units .row .col-name {
  width: 35%;
}
.units .row .col-rirs {
  width: 10%;
}
.units .row .col-sets {
  width: 10%;
}
.units .row .col-reps {
  width: 20%;
}
.units .row .col-info {
  width: 25%;
}
.units .row .col-actions {
  width: 50px;
  min-width: 50px;
}
.units .row.row-header {
  padding-top: 0;
}
.units .row.row-header .col {
  font-family: var(--ons-font-regular);
  color: var(--ons-color-lighter-grey);
}
.units app-training-plan-overview-unit {
  display: block;
  padding-top: 5px;
  padding-bottom: 5px;
}
.units app-training-plan-overview-unit:nth-child(2n) {
  background: var(--ons-color-primary-background);
}
.units .add-button {
  font-size: 13px !important;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 5px;
  width: max-content;
}
.units .add-button ion-icon {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/training-plan-overview/training-plan-overview-sheet/training-plan-overview-sheet.component.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;AACJ;;AACA;EACI,iBAAA;EACA,+CAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;AAAI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;AAER;AAAQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iCAAA;AAEZ;AAAY;EACI,UAAA;AAEhB;AAAY;EACI,UAAA;AAEhB;AAAY;EACI,UAAA;AAEhB;AAAY;EACI,UAAA;AAEhB;AAAY;EACI,UAAA;AAEhB;AAAY;EACI,WAAA;EACA,eAAA;AAEhB;AAEQ;EACI,cAAA;AAAZ;AAEY;EACI,oCAAA;EACA,oCAAA;AAAhB;AAKI;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAKQ;EACI,+CAAA;AAHZ;AAOI;EACI,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AALR;AAOQ;EACI,iBAAA;AALZ","sourcesContent":[".name {\n    font-family: var(--ons-font-bold);\n}\n.units {\n    margin-left: 10px;\n    border-left: 3px solid var(--ons-color-primary);\n    padding-left: 10px;\n    padding-top: 10px;\n\n    .row {\n        display: flex;\n        padding-top: 7px;\n        padding-bottom: 7px;\n\n        .col {\n            color: black;\n            font-size: 12px;\n            text-align: center;\n            font-family: var(--ons-font-bold);\n\n            &-name {\n                width: 35%;\n            }\n            &-rirs {\n                width: 10%;\n            }\n            &-sets {\n                width: 10%;\n            }\n            &-reps {\n                width: 20%;\n            }\n            &-info {\n                width: 25%;\n            }\n            &-actions {\n                width: 50px;\n                min-width: 50px;\n            }\n        }\n\n        &.row-header {\n            padding-top: 0;\n\n            .col {\n                font-family: var(--ons-font-regular);\n                color: var(--ons-color-lighter-grey);\n            }\n        }\n    }\n\n    app-training-plan-overview-unit {\n        display: block;\n        padding-top: 5px;\n        padding-bottom: 5px;\n\n        &:nth-child(2n) {\n            background: var(--ons-color-primary-background);\n        }\n    }\n\n    .add-button {\n        font-size: 13px !important;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        padding-top: 5px;\n        width: max-content;\n\n        ion-icon {\n            margin-right: 5px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
